<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="billetage-form container p-15 p-md-40">
      <h5 class="fw-bold text-black mb-15 mb-md-25">{{ title }}</h5>
      <Form ref="billetageForm" @submit="addOperation" :validation-schema="operationSchema">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
             <div class="div col-md-6">
                <div class="div form-group mb-12">
                  <div class="div d-flex align-items-center justify-content-between">
                    <label class="label d-block text-black fw-semibold mb-5">
                      Bénéficiaire<span class="span text-danger">*</span>
                    </label>
                  </div>
                  <Field name="beneficiaire" class="form-control compact-input "/>
                  <ErrorMessage name="beneficiaire" class="text-danger" />
                </div>
              </div>
            <div class="div col-md-6">
                <div class="div form-group mb-12">
                  <div class="div d-flex align-items-center justify-content-between">
                    <label class="label d-block text-black fw-semibold mb-5">
                      Référence
                    </label>
                  </div>
                  <Field name="referenceDoc" class="form-control compact-input "/>
                  <ErrorMessage name="referenceDoc" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-12">
                  <label class="d-block text-black fw-semibold mb-5">
                    Motif<span class="text-danger">*</span>
                  </label>
                  <Field name="motif" v-slot="{ field }">
                    <Multiselect
                      v-model="motif"
                      :options="motifOptions"
                      :preserve-search="true"
                      :searchable="true"
                      placeholder="Sélectionner le motif"
                      label="label"
                      track-by="value"
                      v-bind="field"
                    />
                  </Field>
                  <ErrorMessage name="motif" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-8 mb-md-12">
                <div class="border border-primary mb-5">
                  <div class="row fw-bold py-2" style="background-color: #a40a0a">
                    <div class="col-md-12 text-center">
                      <h3 class="fs-4 text-white">Billetage Décaissement</h3>
                    </div>
                  </div>
                  <div class="px-3">
                    <div class="row mt-2">
                      <div class="col-md-4"><label class="fw-semibold text-center d-block">Monnaie</label></div>
                      <div class="col-md-4"><label class="fw-semibold text-center d-block">Quantité</label></div>
                      <div class="col-md-4"><label class="fw-semibold text-center d-block">Montant</label></div>
                    </div>
                    <hr class="mt-0" />
                    <template v-for="(billetage, index) in billetageSortieList" :key="index">
                      <div class="container-tight m-0 py-1">
                        <div class="row align-items-center">
                          <div class="col-md-4 px-1">
                            <input
                              name="monnaie"
                              v-model="billetage.libelle"
                              readonly
                              class="form-control compact-input text-center"
                              placeholder="Monnaie"
                            />
                          </div>
                          <div class="col-md-4 px-1">
                            <Field
                              :name="`billetageSortieList[${index}].qteBillet`"
                              type="number"
                              min="0"
                              v-model="billetage.qteBillet"
                              @input="event => handleBilletageInput(event, billetage)"
                              @keypress="restrictInput($event)"
                              class="form-control compact-input text-center"
                              placeholder="Qté"
                            />
                            <ErrorMessage :name="`billetageSortieList[${index}].qteBillet`" class="text-danger compact-error text-center" />
                          </div>
                          <div class="col-md-4 px-1">
                            <input
                              type="text"
                              v-model="billetage.montant"
                              readonly
                              placeholder="Montant"
                              class="form-control compact-input text-center"
                            />
                          </div>
                        </div>
                      </div>
                    </template>
                    <p class="montant-total text-center">Montant Total Décaissement : {{ montantTotalSortie }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 mt-1 text-center">
              <button type="submit" class="btn btn-primary top-end">Envoyer</button>
              <router-link to="/ouv_fers/liste-ouv_fer/" class="btn btn-danger mx-1">Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>

    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage,useForm } from 'vee-validate';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect';
import { Client } from '@/models/Client';
import { Modal } from 'bootstrap';
import { useRouter } from 'vue-router';
  import Swal from 'sweetalert2';
import ApiService from '@/services/ApiService';
import { error, monSwal, success } from '@/utils/utils';
import { Motif } from '@/models/Motif';



interface BilletageForm {
  libelle: string;
  qteBillet: number;
  montant: number;
  monnaie: number;
  valueAct: number;
}

interface SelectOption {
  label: string;
  value: number;
}


export default defineComponent({
  name: "AddDecaissement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  // props: {
  //   title: {
  //     type: String,
  //     required: true,
  //   },
  // },
  setup() {
    const router = useRouter();
    const billetageSortieList = reactive<BilletageForm[]>([]);
    const monnaieList = ref<any[]>([]);
    const montantTotalSortie = ref<number | null>(null);
    const motif = ref<number | null>(null);
    const motifOptions = ref<SelectOption[]>([]);
    const referenceDoc = ref<string>('');
    const beneficiaire = ref<string>('');
    const typeOperationId = ref<number>(2); 
    const { resetForm } = useForm();


    const operationSchema = Yup.object({
      beneficiaire: Yup.string().required('Le bénéficiaire est obligatoire'),
      motif: Yup.number().required('Le motif est obligatoire').nullable(),
      referenceDoc: Yup.string().trim().nullable(),
      billetageSortieList: Yup.array().of(
      Yup.object().shape({
        qteBillet: Yup.number()
          .typeError('La quantité doit être un nombre')
          .required('La quantité est obligatoire')
          .integer('La quantité doit être un entier')
          .min(0, 'La quantité ne peut pas être négative'),
      })
)
    });

    

    const getAllMonnaies = async () => {
      try {
        const res = await ApiService.get("/all/monnaies");
        monnaieList.value = res.data.data.data;
        billetageSortieList.splice(0, billetageSortieList.length);
        monnaieList.value.forEach((element) => {
          billetageSortieList.push({
            libelle: element.libelle,
            montant: 0,
            valueAct: element.valeur,
            monnaie: element.id,
            qteBillet: 0,
          });
        });
      } catch (err) {
        console.error("Erreur lors de la récupération des monnaies:", err);
        error("Erreur lors de la récupération des monnaies");
      }
    };


    // const fetchMotifs = async () => {
    //   try {
    //     const { data } = await ApiService.get(`/motifs/${id}`);
    //     const donnees = data.data.data;
    //     motifOptions.value = donnees.map((mo: Motif) => ({
    //       label: `${mo.nom}`,
    //       value: mo.id,
    //     }));
    //   } catch (err) {
    //     console.error("Erreur lors de la récupération des motifs:", err);
    //     error("Erreur lors de la récupération des motifs");
    //   }
    // };

      const fetchMotifs = async (typeOperationId: number) => {
  try {
  
    // const reqstring = `?typeOperationId=${typeOperationId}`; 
    //   console.log("tessst1", reqstring);
    // const { data } = await ApiService.get(`/motifs/by-type${reqstring}`);
    
    const { data } = await ApiService.query(`/motifs/by-type`, {
    params: { typeOperationId },
    });

        console.log("donnnneees", data);

    const donnees = data.data.data;
    motifOptions.value = donnees.map((mo: Motif) => ({
      label: `${mo.nom}`,
      value: mo.id,
    }));
  } catch (err) {
    console.error("Erreur lors de la récupération des motifs:", err);
    error("Erreur lors de la récupération des motifs");
  }
};
 

    const handleBilletageInput = (event: Event, billetage: BilletageForm) => {
      const newValue = Number((event.target as HTMLInputElement).value);
      billetage.qteBillet = Math.max(0, isNaN(newValue) ? 0 : Math.floor(newValue));
      updateMontant(billetage);
    };

    const updateMontant = (billetage: BilletageForm) => {
      billetage.montant = billetage.qteBillet * billetage.valueAct || 0;
      calculateTotalSortie();
    };

    const calculateTotalSortie = () => {
      const total = billetageSortieList.reduce((total, billetage) => {
        return total + (billetage.montant || 0);
      }, 0);
      montantTotalSortie.value = total || null;
    };


    const cancelOperation = async () => {
      const confirmed = await monSwal(
        'Voulez-vous vraiment annuler l’opération ?',
        'Confirmer',
        'btn btn-primary',
        'Annuler',
        'L’opération a été annulée !'
      );
      if (confirmed) {
        resetForm({
          values: {
            motif: null,
            beneficiaire,
            referenceDoc: '',
            billetageSortieList: billetageSortieList.map(() => ({
              qteBillet: 0,
            })),
          },
        });

        billetageSortieList.length = 0;
        motif.value = null;
        beneficiaire.value = '';
        referenceDoc.value = '';
        montantTotalSortie.value = null;
        await getAllMonnaies();

        router.push('/ajouter-o                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ');
      }
    };

    // const addOperation = async (values: any, { resetForm }: any) => {
    //   try {
    //     const payload = {
    //       clientId: values.client,
    //       motifId: values.motif,
    //       referenceDoc: values.referenceDoc || null,
    //       montant: montantTotalSortie.value, 
    //       typeOperationId: typeOperationId.value,
    //       billetagesSortie: billetageSortieList.filter(billet => billet.qteBillet > 0),
    //       date: new Date(),
    //       type: 'Décaissement',
    //     };

    //     console.log("Payload envoyé:", payload);

    //     await ApiService.post("/decaissements/operations", payload);
    //     success("Décaissement ajouté avec succès");
    //     resetForm();
    //     billetageSortieList.length = 0;
    //     motif.value = null;
    //     client.value = null;
    //     referenceDoc.value = '';
    //     await getAllMonnaies();
    //   } catch (err: any) {
    //     console.error("Erreur lors de l'ajout du décaissement:", err);
    //     error(err.response?.data?.message || "Erreur lors de l'ajout du décaissement");
    //   }
    // };

const addOperation = async (values: any, { resetForm }: any) => {
  try {
    const payload = {
      motifId: values.motif,
      beneficiaire:values.beneficiaire || null,
      referenceDoc: values.referenceDoc || null,
      montant: montantTotalSortie.value,
      typeOperationId: typeOperationId.value,
      billetagesSortie: billetageSortieList.filter(billet => billet.qteBillet > 0),
      date: new Date(),
      type: 'Décaissement',
    };

    console.log("Payload envoyé:", payload);

    await ApiService.post("/decaissements/operations", payload);
    success("Décaissement ajouté avec succès");

    resetForm();
    billetageSortieList.length = 0;
    motif.value = null;
    beneficiaire.value = '';
    referenceDoc.value = '';
    await getAllMonnaies();
    router.push({ name: 'ListeOperationPage' });

  } catch (err: any) {
    console.error("Erreur lors de l'ajout du décaissement:", err);
    const errorMessage = err.response?.data?.message || "Erreur lors de l'ajout du décaissement";

    if (errorMessage.includes("Quantité insuffisante pour la monnaie")) {
      Swal.fire({
        text: errorMessage,
        toast: true,
        icon: "warning",
        position: "top-right",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        heightAuto: false,
      });
    } else {
      error(errorMessage);
    }
  }
};

    watch(billetageSortieList, () => {
      calculateTotalSortie();
    }, { deep: true });

    onMounted(() => {
      getAllMonnaies();
      fetchMotifs(typeOperationId.value);
    });

    const restrictInput = (event: KeyboardEvent) => {
      if (event.key === '-' || (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace')) {
        event.preventDefault();
      }
    };

    return {
      billetageSortieList,
      montantTotalSortie,
      operationSchema,
      restrictInput,
      handleBilletageInput,
      addOperation,
      motif,
      motifOptions,
      beneficiaire,
      referenceDoc,
      cancelOperation,
    };
  },
});
</script>

<style scoped>
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.montant-total {
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 8px;
}

.text-danger {
  font-size: 0.75rem;
  color: #dc3545;
}

.compact-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  height: 30px;
}

.compact-error {
  font-size: 0.75rem;
  margin-top: 2px;
}

.container-tight {
  margin: 0;
  padding: 2px 0;
}
</style>